import React from 'react';
import styled from 'styled-components';
import { Card as MuiCard } from '@material-ui/core';

const Card = styled(MuiCard)`
  width: 500px;
  overflow: visible;

  @media (max-width: 768px) {
    height: 100vh;
    width: 100vw;
  }
`;

const ResponsiveCard: React.FC = ({ children }) => {
  return <Card>{children}</Card>;
};

export default ResponsiveCard;
